export default {"src":"/_next/static/media/0x30d2a9f5fdf90ace8c17952cbb4ee48a55d916a7.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};